import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, onMounted, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeField',
  props: {
    value: null,
    disabled: { type: Boolean },
    label: null,
    name: null
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: number;
  disabled?: boolean;
  label: string;
  name: string;
}





const SUFFIX = " s";

watch(
  () => props.value,
  () => {
    addSuffix();
  }
);

const input = ref<HTMLInputElement>();

const stripNonNumeric = (value: string) => {
  return value.replace(/[^0-9.]/g, "");
};

const inputValue = computed(() => {
  return props.value.toFixed(1);
});

const onChange = ({ target }: Event) => {
  if (target instanceof HTMLInputElement) {
    const numeric = stripNonNumeric(target.value);
    const float = parseFloat(numeric);

    if (isNaN(float)) {
      target.value = props.value.toFixed(1);
    } else {
      emits("input", float);
    }
  }
};

const addSuffix = () => {
  nextTick(() => {
    if (input.value instanceof HTMLInputElement) {
      input.value.value = inputValue.value + SUFFIX;
    }
  });
};

const removeSuffix = () => {
  if (input.value instanceof HTMLInputElement) {
    input.value.value = stripNonNumeric(input.value.value);
  }
};

onMounted(() => {
  addSuffix();
});

return { __sfc: true,props, emits, SUFFIX, input, stripNonNumeric, inputValue, onChange, addSuffix, removeSuffix }
}

})